import { useRef, useEffect, useCallback } from 'react';

export default function useDebouncedCallback<T extends (...args: any[]) => void>(
	callback: T,
	delay: number
) {
	const timeoutRef = useRef<NodeJS.Timeout | null>(null);

	const debouncedFn = useCallback(
		(...args: Parameters<T>) => {
			if (timeoutRef.current) clearTimeout(timeoutRef.current);
			timeoutRef.current = setTimeout(() => {
				callback(...args);
			}, delay);
		},
		[callback, delay]
	);

	useEffect(() => {
		return () => {
			if (timeoutRef.current) clearTimeout(timeoutRef.current);
		};
	}, []);

	return debouncedFn;
}
